var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Website Name ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      "What is the name of your " +
                        _vm._s(_vm.websitetype) +
                        "?"
                    )
                  ]),
                  _c("gg-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: "Name",
                      "data-vv-name": "ws_name",
                      "data-vv-as": "Name",
                      name: "ws_name",
                      "error-messages": _vm.errors.collect("ws_name")
                    },
                    model: {
                      value: _vm.name,
                      callback: function callback($$v) {
                        _vm.name = $$v
                      },
                      expression: "name"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }